module.exports = __webpack_public_path__ + "media/images/lp_consultation/ic-check-green-e8dac0514cbd505060b600a49fe305b6.svg";